<template>
    <v-form ref="form_referencia_financiera">
        <v-container fluid grid-list-md v-show="_.size(listGeneral.cabeceraReferenciaFinanciera) > 0">
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-dialog v-model="abrirModal" :max-width="tamModal" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
                        <template v-slot:activator="{ on }">
                            <div class="text-right">
                                <v-btn rounded dark color="primary" v-on="on">Nuevo</v-btn>
                            </div>
                        </template>
                        <v-card>
                            <v-card-title class="bg-title-card">
                                <span class="white--text headline" v-html="titulo"></span>
                            </v-card-title>
                            <v-container fluid grid-list-md>
                                <v-form ref="form_modal_referencia_financiera">
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Tipo Cuenta *" color="textbox"
                                                v-model="objeto.idTipoCuenta" :items="listGeneral.listaTipoCuenta"
                                                item-value="idTipoCuenta" item-text="cuenta" autocomplete
                                                :rules="requeridoRegla" outlined dense> </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field label="Número Cuenta *" color="textbox"
                                                v-model="objeto.nroCuenta" :rules="_.concat(requeridoRegla,numeroRegla)"
                                                outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Institución Financiera *" color="textbox"
                                                v-model="objeto.idInstitucionFinanciera"
                                                :items="listGeneral.listaInstitucion"
                                                item-value="idInstitucionFinanciera" item-text="institucion"
                                                :rules="requeridoRegla" outlined dense></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                                            <v-btn outlined dense rounded color="danger" class="mr-1" @click="reset">
                                                Cancelar</v-btn>
                                            <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6"/>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="objeto.busqueda" prepend-inner-icon="search"
                        dense>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-data-table :search="objeto.busqueda" :headers="listGeneral.cabeceraReferenciaFinanciera"
                        :items="listGeneral.listaReferenciaFinanciera" class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="objeto.busqueda"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                    <v-btn outlined dense rounded color="danger" class="mr-1" @click="previous('objRefBan',objForm);">Anterior</v-btn>
                    <v-btn rounded dark color="primary" class="mr-1" @click="validar(2)" :disabled="disabled">Guardar</v-btn>
                    <v-btn rounded dark color="primary" @click="validar(1)" :disabled="disabled">Enviar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperReferenciaFinancieraComponent',
        inject: ['previous', 'next','setValidateStep','insertarActualizar'],
        props: {
            cargar: {
                type: Boolean,
                default: false
            },
            objForm: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros:{
                type: Object,
                default: {}
            }
        },
        data: () => ({
            abrirModal: false,
            titulo: 'Nueva Referencia Institución Financiera',
            disabled: false,
            objeto: {
                idTipoCuenta: null,
                nroCuenta: null,
                idInstitucionFinanciera: null
            }
        }),
        watch: {
            cargar(val) {
                if (val && _.size(this.listGeneral.listaReferenciaFinanciera) == 0) {
                    this.objeto = _.clone(this.objForm);
                    var request = [ 
                                this.onListarCatalogo('administrador/catalogo-estado/listar',{opcion:'TIPO_CUENTA'},'listaTipoCuenta'), 
                                this.onListarCatalogo('administrador/prevension-lavado-activo/contratante/listar',{opcion:'CAB_REFERENCIA_FINANCIERA'},'cabeceraReferenciaFinanciera'), 
                                this.onListarCatalogo('administrador/institucion-financiera/listar',{opcion:'LISTAR_COMBO'},'listaInstitucion'), 
                            ];

                    Promise.all(request)
                            .then((r) => {
                                if( _.size(this.listGeneral.listaTipoCuenta) == 0) throw 'No se encontraron datos con el criterio de búsqueda.';
                                    var l = _.cloneDeep(_.filter(this.listGeneral.listaTipoCuenta,{ 'visualiza':'true' }));
                                    this.next('listaTipoCuenta',l,false);
                                    
                                    var o = _.merge({},
                                                    {opcion: 'LISTAR_REFERENCIA_FINANCIERA'},
                                                    _.pick(this.objeto,['idFormulario','idPoliza','idContratante'])
                                                    );

                                    return this.onListarCatalogo('administrador/prevension-lavado-activo/contratante/listar',o,'listaReferenciaFinanciera');
                            })
                            .then((r) => {
                                var l = [];
                                l = _.cloneDeep(this.listGeneral.listaReferenciaFinanciera);
                                l = _.map(l,(v)=>{
                                        v.id = _.uniqueId();
                                        v.index = _.toString(v.index);
                                        return v;
                                    });

                                this.next('listaReferenciaFinanciera',l,false);
                            })
                            .catch((e) => { 
                                console.info(e);
                            });
                }
            }
        },
        methods: {
            onListarCatalogo(ruta,objeto,lista){
                var error = 'E';
                this.next(lista,[],false);

                return axios.post(`${BASE_URI}${ruta}`,objeto)
                            .then((r)=>{
                                if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    this.next(lista,r.data.data,false);

                                return r;
                            })
                            .catch((e) => { 
                                mensajesAlerta(e,error); 
                                return e;
                            });
            },
            validar(event){
                switch (event) {
                    // Enviar -> Valida
                    case 1:
                        try {
                            if(this.disabled) throw 'Ya se encuentra un petición en progreso';
                            if(_.size(this.listGeneral.listaReferenciaFinanciera) == 0) throw mensajeEstandar.referenciaFinanciera;
                                var stepsValidacion = [ 'datosContratante', 'datosRepresentante','datosArchivos','datosFinancieros'];
            
                                // Componentes hijos a validar
                                var steps = [  
                                    this.$parent.$parent.$children[1].$children[0].$refs.form_datos_generales,
                                    this.$parent.$parent.$children[3].$children[0].$refs.form_datos_representante,
                                    this.$parent.$parent.$children[5].$children[0].$refs.form_documentos,
                                    this.$refs.form_referencia_financiera
                                ];

                                var validacion = true;
                                var compoValidacionSteps = this.$parent.$parent.$parent.$parent;
                                
                                this.setValidateStep({'mostrarMensajeErrorArchi':false});
                                this.setValidateStep({'mostrarMensajeErrorFina':false});

                                    for (let index = 0; index < steps.length; index++) {
                                        var k = stepsValidacion[index];
                                        this.setValidateStep({k: [ () => true ]});
                
                                        if(!steps[index].validate()){
                                            this.setValidateStep({k: [ () => false ]});
                                        
                                            if(k == 'datosArchivos')
                                                this.setValidateStep({'mostrarMensajeErrorArchi':true});
                
                                            if(k == 'datosFinancieros')
                                                this.setValidateStep({'mostrarMensajeErrorFina':true});
                
                                            compoValidacionSteps.e6 = index + 1;
                                            validacion = false;
                                            break;
                                        }
                                    }
                                    
                                if(!validacion) throw mensajeEstandar.corregirInformacion;
                                    this.next('objDatosGenerales',{idEstadoProcesado:_.get(this.parametros,'idEstadoDefault',null)});
                                    this.insertarActualizar()
                                        .then((r)=>{
                                            if(!r) throw 'ERROR';                                                
                                        })
                                        .catch((e)=>{
                                            this.disabled = false;
                                        });
                        } catch (e) {
                            mensajesAlerta(e,'I');
                            this.disabled = false;
                        }
                        break;
                    // Guardar        
                    case 2:
                        try {
                            if(this.disabled) throw 'Ya se encuentra un petición en progreso';
                                this.next('objDatosGenerales',{idEstadoProcesado:this.parametros.idEstadoInactivo},false);
                                this.insertarActualizar()   
                                    .then((r)=>{
                                        if(!r) throw 'ERROR';                                                
                                    })
                                    .catch((e)=>{
                                        this.disabled = false;
                                    });
                        } catch (e) {
                            mensajesAlerta(e,'I');
                            this.disabled = false;
                        }
                        break;
                }
            },
            validarModal(){
                try {
                    if(!this.$refs.form_modal_referencia_financiera.validate()) throw mensajeEstandar.corregirInformacion;
                        var l = this.listGeneral.listaReferenciaFinanciera;

                        if(_.isUndefined(this.objeto.id)){
                            this.objeto.id          = _.uniqueId();
                            this.objeto.tipoCuenta  = _.find(this.listGeneral.listaTipoCuenta, (o) => { return o.idTipoCuenta == this.objeto.idTipoCuenta}).cuenta;
                            this.objeto.institucion = _.find(this.listGeneral.listaInstitucion, (o) => { return o.idInstitucionFinanciera == this.objeto.idInstitucionFinanciera }).institucion;
                            l.push(this.objeto);
                        }
                        else{
                            var pos = _.findIndex(l,(v) => { return parseInt(v.id) == parseInt(this.objeto.id); });
                            l[pos] = _.merge(l[pos],this.objeto);
                        }
                        this.next('listaReferenciaFinanciera',l,false);
                        this.reset();          
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            onEditar(obj,index){
                this.objeto = _.merge(this.objeto,obj);
                this.titulo = 'Editar Referencia Institución Financiera';
                this.abrirModal = !this.abrirModal;
            },
            reset(){
                this.$refs.form_modal_referencia_financiera.resetValidation();
                this.abrirModal = false;
                this.titulo = 'Nueva Referencia Institución Financiera';
                this.objeto = _.clone(this.objForm);
            }
        }
    }
</script>